// Barrel module for app-level scripts, i.e. behaviour tied to the shell
// markup in app/templates/_base.twig (sidebar, header, canvas). Mirrors
// src/scss/app/app.scss. Import individual app modules here, e.g:
// import './header.js';

// Header nav overlay. The nav is a native popover opened by the hamburger
// (popovertarget), which handles toggling, outside clicks and Escape. The
// hamburger is only visible below the header container breakpoint (see
// _app_header.scss).
const navToggle = document.querySelector('header .nav-toggle');
const nav = navToggle && document.getElementById(navToggle.getAttribute('aria-controls'));

if (nav) {
  const header = navToggle.closest('header');
  const breakpoint = 940; // Keep in sync with $bp-header-nav

  // Mirror open state onto the button (drives the hamburger -> X morph)
  nav.addEventListener('toggle', (e) => {
    navToggle.setAttribute('aria-expanded', String(e.newState === 'open'));
  });

  // Close when a link is followed (matters for in-page/HTMX navigation)
  nav.addEventListener('click', (e) => {
    if (e.target.closest('a') && nav.matches(':popover-open')) nav.hidePopover();
  });

  // Close if the header grows past the breakpoint while open
  new ResizeObserver(([entry]) => {
    if (entry.contentBoxSize[0].inlineSize >= breakpoint && nav.matches(':popover-open')) {
      nav.hidePopover();
    }
  }).observe(header);
}
